<template>
    <v-snackbar
        v-model="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :location="snackbar.location"
        close-on-content-click
        transition="v-snackbar-transition"
        multi-line
        class="prospus-snackbar"
        :class="snackbar.class"
        @click:outside="onClickOutside"
    >
        <div class="prospus-snackbar-content">
            <v-avatar v-if="snackbar.avatar_url" size="35" class="mr-2">
                <v-img :src="snackbar.avatar_url"></v-img>
            </v-avatar>

            <Icon
                v-if="snackbar?.icon"
                google
                :size="snackbar?.icon?.size ?? '18'"
                :color="snackbar?.icon?.color"
                :active-class="snackbar?.icon?.activeClass"
            >
                {{ snackbar?.icon?.name }}
            </Icon>

            <div class="prospus-snackbar__wrapper">
                <h3
                    v-if="snackbar.title"
                    class="prospus-snackbar__title mb-2 text-white"
                    v-html="snackbar.title"
                ></h3>
                <p
                    class="prospus-snackbar__message text-white"
                    v-html="snackbar.message"
                ></p>
            </div>
        </div>
        <template #actions>
            <v-btn
                v-if="snackbar.button_text && snackbar.button_url"
                color="white"
                variant="text"
                @click.prevent="
                    downloadFile(snackbar.button_url);
                    snackbar.visible = false;
                "
            >
                {{ snackbar.button_text }}
            </v-btn>

            <v-btn
                color="white"
                variant="text"
                @click="snackbar.visible = false"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script setup>
import Utilities from "../../../Helpers/utilities";
const { snackbar, setSnackbarClickedOutside } = Utilities();

function onClickOutside() {
    setSnackbarClickedOutside();
}

function downloadFile(url) {
    const secureUrl = url.startsWith("http://")
        ? url.replace("http://", "https://")
        : url;
    const link = document.createElement("a");
    link.href = secureUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
</script>

<style>
.snake-bar-chat-and-doc {
    --v-layout-right: 90px !important;
}
</style>
